import template from './combined-wcs-count.jade';

export default angular
  .module('cian.addForm.combinedWcsCount', [])
  .directive('cianAfAboutObjectCombinedWcsCount', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService) {
      'ngInject';

      this.isMobile = deviceService.isMobile;

      this.items = [
        {
          value: undefined,
          text: 'Нет',
        },
        ...[1, 2, 3, 4].map(n => ({ value: n, text: n })),
      ];

      if (!this.ad.combinedWcsCount) {
        this.ad.combinedWcsCount = this.items[0].value;
      }
    },
    controllerAs: 'combinedWcsCount',
    template,
  })).name;
